import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Switch from "react-switch";
import { FaAngleLeft } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewjob = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [description, setDescription] = useState("");
  const [data, setData] = useState([]);
  const id = useParams();

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const fetchJobdata = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-joblisting-byid",
      headers: {
        "x-access-token": token,
      },
      data: {
        id: id.jobId,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data.data[0]);
        setChecked(response.data.data[0].status);
        setDescription(response.data.data[0].description);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchJobdata();
  }, []);

  useEffect(() => {
    if (data) {
      setValue("tittle", data?.title);
      setValue("employment", data?.employmentType);
      setValue("startDate", data?.datePosted);
      setValue("endDate", data?.validThrough);
      setValue("email", data?.email);
      setValue("experince", data?.experience);
      setValue("location", data?.location);
    }
  }, [data]);
  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Job</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div"></div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>Job Title</label>
                <input
                  type="text"
                  name="tittle"
                  disabled={true}
                  {...register("tittle")}
                  placeholder="Enter Job Tittle"
                />
              </div>
              <div className="formInput">
                <label>Employment Type</label>
                <input
                  type="text"
                  name="employment"
                  disabled={true}
                  {...register("employment")}
                  placeholder="Enter Employment Type"
                />
              </div>
              <div className="formInput">
                <label>Job Location</label>
                <input
                  type="text"
                  name="location"
                  disabled={true}
                  {...register("location")}
                  placeholder="Enter Job Location"
                />
              </div>
              <div className="formInput">
                <label>Experience</label>
                <input
                  type="text"
                  name="experince"
                  disabled={true}
                  {...register("experince")}
                  placeholder="Enter Experince"
                />
              </div>
              <div className="formInput">
                <label>Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  disabled={true}
                  {...register("startDate")}
                  placeholder="Enter Start Date"
                />
              </div>
              <div className="formInput">
                <label>End Date</label>
                <input
                  type="date"
                  name="endDate"
                  disabled={true}
                  {...register("endDate")}
                  placeholder="Enter End Date"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  {...register("email")}
                  placeholder="Enter Email"
                />
              </div>
              <div className="formInput">
                <label>Status</label>
                <Switch disabled={true} checked={checked == 1 ? true : false} />
              </div>
              <div className="formInputDescription">
                <label>Job Description</label>
                <Editor
                  textareaName="description"
                  disabled={true}
                  initialValue={data?.description}
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  //     onEditorChange={(newText) => setDescription(newText)}
                />
              </div>

              {/* <button className="submitBtn">Save</button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewjob;
